<template>
    <div class="message_container flex-col mb-6">
        <div class="flex mb-2">
            <div v-if="chat.contentType !== 'note'" class="message" :class="chat.contentType === 'email' ? 'message-box-email !gap-0': ''">
                <div class="flex items-center justify-between gap-6">
                    <div v-if="chat.contentType === 'text'" class="text_container">
                        <!-- [info]: using this after sanitizing the HTML -->
                        <div v-html="markdownToHTML(chat.content)" class=""></div>
                        <p v-if="Array.isArray(chat.reactions) && chat.reactions.length">
                            <label>{{ chat.reactions[0] }}</label>
                        </p>
                    </div>
                    <div v-if="chat.contentType === 'email'" class="message email-message">
                        <!-- <pre>{{ chat }}</pre> -->
                        <div v-if="chat.emailMetadata" class="message-meta-data mb-4">
                            <div>
                                <span class="text-black-500 text-sm font-normal mr-1">From:</span>
                                <span class="text-black-500 text-sm font-normal"> {{ chat.sender.email }}</span>
                            </div>
                            <div>
                                <span class="text-black-500 text-sm font-normal mr-1">To:</span>
                                <span class="text-black-500 text-sm font-normal"> {{ chat.emailMetadata.to }}</span>
                            </div>
                            <div>
                                <span class="text-black-500 text-sm font-normal mr-1">Subject:</span>
                                <span class="text-black-500 text-sm font-normal"> {{ chat.emailMetadata.subject }}</span>
                            </div>
                            <div v-if="chat.emailMetadata?.cc">
                                <span class="text-black-500 text-sm font-normal mr-1">Cc:</span>
                                <span class="text-black-500 text-sm font-normal"> {{ chat.emailMetadata.cc }}</span>
                            </div>
                            <div v-if="chat.emailMetadata?.bcc">
                                <span class="text-black-500 text-sm font-normal mr-1">Bcc:</span>
                                <span class="text-black-500 text-sm font-normal"> {{ chat.emailMetadata.bcc }}</span>
                            </div>
                        </div>
                        <div class="email-message-content" v-html="chat.content"></div>
                    </div>
                    <div v-if="chat.contentType === 'bot'">
                        <template v-for="(items, index) of JSON.parse(chat?.botLinkedData?.currentBot)" :key="index">
                            <template v-for="(item, indexx) in items" :key="indexx">
                                <template v-if="item.id === chat?.botLinkedData?.currentNodeID">
                                    <div v-html="getSanitizeHTML(item.data.modelValText)"></div>
                                    <div class="grid grid-cols-2 gap-2 mt-3" v-if="item.data.actionButtons.length">
                                        <template v-for="(button, index) in item.data.actionButtons" :key="index">
                                            <AppButton icon-type="fas" variant="blue" :btn-text="button.buttonText" />
                                        </template>
                                    </div>
                                </template>
                            </template>
                        </template>
                    </div>
                    <!-- <div v-if="chat.contentType === 'image'">
                        <img
                            v-for="(image, index) in chat.content"
                            :key="index" 
                            class="bg-gray-100 rounded-xl rounded-tl-none text-sm mb-2 h-40 w-full object-cover cursor-pointer"
                            :src="image"
                        />
                    </div> -->
                    <div v-if="chat.contentType === 'image'" class="max-w-[278px] rounded-xl !rounded-tr-none">
                        <div :class="chat.content.length > 1 ? 'grid grid-cols-2 gap-1' : ''">
                            <div
                                v-for="(image, index) in chat.content.slice(0, 4)"
                                :key="index"
                                class="relative rounded-none [&:nth-child(even)]:rounded-tr-xl [&:nth-child(4)]:rounded-br-xl [&:nth-child(4)]:!rounded-tr-none [&:nth-child(odd)]:rounded-tl-xl [&:nth-child(3)]:!rounded-bl-xl [&:nth-child(3)]:!rounded-tl-none"
                                :class="
                                    chat.content.length === 2
                                        ? '[&:nth-child(1)]:!rounded-bl-xl [&:nth-child(2)]:!rounded-br-xl'
                                        : ''
                                "
                            >
                                <template v-if="chat.content.length > 1">
                                    <img
                                        :key="index"
                                        class="bg-gray-100 text-sm h-24 w-auto rounded-[inherit]"
                                        :src="image"
                                    />
                                    <div
                                        v-if="index === 3 && chat.content.length > 3"
                                        @click="galleryOpen"
                                        class="absolute backdrop-blur-[4px] w-full h-full top-0 rounded-none bg-black bg-opacity-60 rounded-br-xl flex items-center justify-center !text-[34px] font-normal !text-white"
                                    >
                                        +4
                                    </div>
                                </template>
                                <img
                                    v-else
                                    :key="index"
                                    class="bg-gray-100 rounded-xl rounded-tl-none text-sm mb-2 h-40 w-auto"
                                    :src="image"
                                />
                            </div>
                        </div>
                        <GallerySlider
                            ref="galleryModalRef"
                            class="fvrt-icon"
                            :chat="chat"
                            modalShowVal="galleryModal"
                        />
                    </div>
                    <div v-if="chat.contentType === 'document'" class="max-w-[278px] rounded-xl rounded-tr-none">
                        <a
                            v-for="(doc, index) in chat.content"
                            :key="index"
                            class="decoration-none items-center text-sm flex gap-2 h-auto w-auto text-black-100"
                            :href="doc"
                        >
                            <fa
                                class="h-6"
                                :class="
                                    fileIcon[getFileType(doc)].includes('file-word')
                                        ? 'text-[#0744C2]'
                                        : fileIcon[getFileType(doc)].includes('file-pdf')
                                          ? 'text-red-300'
                                          : 'text-green-600     '
                                "
                                :icon="fileIcon[getFileType(doc)]"
                            />

                            <div>
                                <span class="text-ellipsis overflow-hidden block max-w-[210px]">
                                    {{ formatFileName(doc) }}
                                </span>
                                <p class="flex items-center gap-1 text-gray-400 !text-xs">
                                    <!-- Dummy size & extension for now -->
                                    456kb
                                    <fa class="h-2" :icon="['fas', 'circle']" />
                                    {{ getFileType(doc) }}
                                </p>
                            </div>
                            <!-- <span>{{ doc.split('VOZACHAT/')[1] }}</span> -->
                        </a>
                    </div>
                    <div v-if="chat.contentType === 'video'" class="min-w-[20rem]">
                        <video
                            v-for="(vid, index) in chat.content"
                            :key="index"
                            width="320"
                            height="240"
                            controls
                            class="bg-gray-100 rounded-xl rounded-tl-none text-sm mb-2 h-40 w-full"
                        >
                            <source :src="vid" type="video/mp4" />
                        </video>
                    </div>
                    <div v-if="chat.contentType === 'audio'">
                        <audio
                            v-for="(aud, index) in chat.content"
                            :key="index"
                            width="320"
                            height="240"
                            controls
                            class="bg-gray-100 rounded-xl rounded-tl-none text-sm mb-2 h-10"
                        >
                            <source :src="aud" type="audio/mpeg" />
                        </audio>
                    </div>
                </div>
                <div v-if="chat.contentType === 'email'" class="mx-auto mr-0 pr-6 mt-4 mb-4 cursor-pointer" @click="viewMoreOpen">
                    View more <fa :icon="['fas', 'chevron-down']"></fa> 
                </div>
            </div>
            <div v-if="chat.contentType === 'note'" class="message notes">
                <!-- [info]: using this after sanitizing the HTML -->
                <div v-html="markdownToHTML(chat.note)" class=""></div>
            </div>

            <!-- <img
                v-if="
                    chat?.sender?.role === 'Contact' &&
                    JSON.parse(chat?.botLinkedData?.currentBot)?.name
                "
                class="n_icon"
                src="https://voza-chat.blr1.digitaloceanspaces.com/VOZACHAT/bot.png"
                style="height: 24px; width: 24px"
            /> -->
            <div
                v-if="chat?.sender?.role === 'Contact' && JSON.parse(chat?.botLinkedData?.currentBot)?.name"
                class="n-icon ml-2 bg-[#A3A3A3] flex items-center justify-center pt-[1px] h-6 w-6 rounded-full"
            >
                <fa :icon="['fal', 'message-bot']" class="text-xs text-white" />
            </div>

            <img v-else :src="chat?.sender?.pic || defaultUserImage" alt="" class="n_icon" />
        </div>
        <div v-if="!isBottomHidden" class="flex gap-1">
            <span class="text-xs font-medium text-gray-500">
                {{ moment(new Date(chat.createdAt)).fromNow() }}
            </span>
            <!-- <fa :class="`text-[#00B0FC]`" :icon="['fal', 'check-double']"></fa>   -->
            <span v-if="checkIfMessageSeen() === true" class="text-sm text-blue-500 mr-1 leading-[14px]">
                <fa :icon="['fal', 'check-double']" class="text-sm" />
            </span>
        </div>
    </div>

    <div class="clear"></div>
    <ViewMoreModal ref="viewMoreRef" modal-show-val="viewMoreModal" size="large" />
</template>
<script setup>
import { ref } from "vue";
import moment from "moment/moment";
import AppButton from "@/components/appComponents/AppButton.vue";
import ViewMoreModal from "@/components/settings/inbox/inbox-component/modals/ViewMoreModal.vue";
import { convertMarkdownIntoHTML, getSanitizeHTML } from "@/utils/markdown";
import GallerySlider from "@/components/appComponents/chat/GallerySlider.vue";

const defaultUserImage = `${import.meta.env.VITE_APP_S3_BASE_URL}/static-content/default-user.png`;

const props = defineProps({
    chat: {
        type: Object,
        default: {},
    },
    chatRoomContacts: {
        type: Array,
        default: [],
    },
    isBottomHidden: {
        type: Boolean,
        default: false,
    },
});
const viewMoreRef = ref();

const viewMoreOpen = () => {
    viewMoreRef.value.showModal("viewMoreModal");
};
const markdownToHTML = (markdown) => {
    if (!markdown) return "";
    return convertMarkdownIntoHTML(markdown);
};

const galleryModalRef = ref("");
const galleryOpen = () => {
    console.log("working fine start");
    galleryModalRef.value.showModal("galleryModal");
    console.log("working fine end");
};
const checkIfMessageSeen = () => {
    let allContactSeen = true;
    props.chatRoomContacts?.map((contact) => {
        if (!props?.chat?.readBy.includes(contact?._id)) {
            allContactSeen = false;
            return;
        }
    });
    return allContactSeen;
};
// Extract cleaned filename
const formatFileName = (doc) => {
    try {
        const raw = decodeURIComponent(doc.split("VOZACHAT/")[1] || "");
        const cleaned = raw
            .replace(/^\d+__/, "") // Remove numeric prefix
            .replace(/\s+/g, "_") // Replace spaces with underscores
            .toLowerCase();
        return cleaned;
    } catch {
        return "unknown_file";
    }
};

// Get file type
const getFileType = (doc) => {
    const ext = doc.split(".").pop().toLowerCase();
    if (ext === "pdf") return "pdf";
    if (["xls", "xlsx", "csv"].includes(ext)) return "excel";
    if (["doc", "docx"].includes(ext)) return "word";
    return "default";
};

// Icon map
const fileIcon = {
    pdf: ["fal", "file-pdf"],
    excel: ["fal", "file-excel"],
    word: ["fal", "file-word"],
    default: ["fal", "file"],
};
</script>
<style scoped>
.message_container {
    display: flex;
    align-items: baseline;
    float: right;
}
.message_container .message {
    display: flex;
    padding: 16px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-radius: 16px 0px 16px 16px;
    background: #a9e5ff;
    max-width: 604px;
    min-width: 120px;
    @apply !text-sm !font-medium !text-black-600;
}
.message_container .message p {
    color: var(--Black-text, #2b2c30);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.message_container .message div {
    /* @apply !text-sm !font-medium !text-black-600; */
}
.message_container .notes {
    background: rgb(254 249 188 / var(--tw-bg-opacity));

    /* align-items: flex-start;
    align-self: stretch;
    background: rgb(254 249 188 / var(--tw-bg-opacity));
    border-radius: 16px 0px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 214px;
    min-width: 0px;
    padding: 16px 24px; */
}
.clear {
    clear: both;
}
.n_icon {
    align-items: center;
    border-radius: 99px;
    color: #fff;
    display: flex;
    flex-direction: column;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    gap: 10px;
    height: 24px;
    justify-content: center;
    line-height: normal;
    padding: 0;
    position: relative;
    text-align: center;
    width: 24px;
    margin-left: 10px;
}
.email-message{
    padding:0;
    padding-bottom: 0!important;
}
.email-message .email-message-content{
    padding: 16px 48px;
    background-color:#ffffff;
    border-radius: 4px;

}
.email-message .message-meta-data{
    font-size: 14px;
    font-weight: 400;
    color: #2B2C30;
}
.message-box-email{
    padding:0!important;
}
</style>

<style>
.chat_content * {
    background: transparent !important;
}
</style>
